import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MaterialBottomSheetOffer } from '../../../business/material-bottom-sheet/material-bottom-sheet-offer';

@Component({
    selector: 'ecm-mat-bottom-sheet-offer-section',
    templateUrl: 'material-bottom-sheet-offer-section.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialBottomSheetOfferSectionComponent {
    public offerSection = input<MaterialBottomSheetOffer>(null);
}
